import { clearAuthToken, refreshAuthToken } from "auth/authToken";
import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { useAuth } from "./useAuth";

export const useEnsureAuthenticated = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { isAuthenticated } = useAuth();

    return useCallback(async (): Promise<boolean> => {
        if (!isAuthenticated()) {
            clearAuthToken();
            navigate("/auth", { state: { from: location } });
            return false;
        }

        try {
            await refreshAuthToken();
            return true;
        } catch {
            clearAuthToken();
            navigate("/auth", { state: { from: location } });
            return false;
        }
    }, [isAuthenticated, navigate, location]);
};
